// Зареждането на листа „Инвентаризация" при редакция — точно веднъж при
// отваряне (записаната инвентаризация). Черновата на НОВА (от сървъра или
// локалната, с въпрос, освен ако изборът е направен на началния екран) е
// общата `components/drafts/useDraftResume`. Зареждането НЕ минава през
// `touch` — не вдига „незапазени промени".
import { useEffect, useRef } from "react";
import { getStocktake, type Stocktake } from "../../../../api/inventory";
import type { DraftRouterState } from "../../components/drafts/draftModel";

// Изборът от началния екран при незавършена инвентаризация и черновата от
// сървъра (`DraftRouterState`) + „Започни" за конкретен склад
export type StocktakeRouterState = (DraftRouterState & { warehouseId?: number }) | null;

type Actions = {
  applyEdit: (stocktake: Stocktake) => void;
  onLoadError: () => void;
};

type Params = {
  mode: "new" | "edit";
  stocktakeId: string | undefined;
  actions: Actions;
};

export const useStocktakeLoad = ({ mode, stocktakeId, actions }: Params) => {
  const loadedRef = useRef(false);
  const actionsRef = useRef(actions);
  actionsRef.current = actions;

  useEffect(() => {
    if (loadedRef.current || mode !== "edit") return;
    loadedRef.current = true;
    const id = Number(stocktakeId);
    if (!id) return;
    // Отговорът се прилага с актуалните действия (справочниците може вече
    // да са заредени — знаците след запетаята идват от тях)
    getStocktake(id)
      .then((stocktake) => actionsRef.current.applyEdit(stocktake))
      .catch(() => actionsRef.current.onLoadError());
  }, [mode, stocktakeId]);
};
